// Code-snippet tabs (SDK/CLI/HTTP) embedded at the top of each capability
// page, so integration instructions live with the feature instead of a
// separate docs site. Snippets are static hand-written text - this just
// renders them, it doesn't execute anything. The real demo is the
// interactive form on the page itself.
import { el, copyToClipboard } from "./dom";
import { iconCopy } from "./icons";
import { showToast } from "./toast";

export interface SnippetSet {
  sdk?: string;
  cli?: string;
  http?: string;
}

const TAB_LABELS: Record<keyof SnippetSet, string> = {
  sdk: "SDK (JS/TS)",
  cli: "CLI",
  http: "HTTP",
};

export function renderSnippetTabs(snippets: SnippetSet): HTMLElement {
  const keys = (Object.keys(snippets) as (keyof SnippetSet)[]).filter((k) => snippets[k]);
  const tabButtons: HTMLElement[] = [];
  const pane = el("pre", { class: "snippet-pane" }, [el("code", {}, [])]);
  const copyBtn = el("button", { type: "button", class: "icon-btn", "aria-label": "Copy snippet" }, [iconCopy()]);

  let active: keyof SnippetSet = keys[0];

  function render() {
    const text = snippets[active] ?? "";
    pane.innerHTML = "";
    pane.append(el("code", {}, [text]));
    for (const btn of tabButtons) {
      btn.classList.toggle("active", btn.dataset.snippetTab === active);
    }
  }

  for (const key of keys) {
    const btn = el("button", { type: "button", class: "snippet-tab", "data-snippet-tab": key }, [TAB_LABELS[key]]);
    btn.addEventListener("click", () => {
      active = key;
      render();
    });
    tabButtons.push(btn);
  }

  copyBtn.addEventListener("click", async () => {
    const ok = await copyToClipboard(snippets[active] ?? "");
    showToast(ok ? "Snippet copied." : "Couldn't copy - select and copy it manually.", ok ? "success" : "error");
  });

  render();

  return el("div", { class: "snippet-tabs" }, [
    el("div", { class: "snippet-tabs-row" }, [el("div", { class: "snippet-tabs-buttons" }, tabButtons), copyBtn]),
    pane,
  ]);
}
